import { defineComponent as x, h as e } from "vue";
import P from "./ghl-ui.es862.js";
import v from "./ghl-ui.es866.js";
import k from "./ghl-ui.es863.js";
import b from "./ghl-ui.es864.js";
import w from "./ghl-ui.es865.js";
const C = {
  success: e(v, null),
  error: e(k, null),
  warning: e(b, null),
  info: e(w, null)
}, O = x({
  name: "ProgressCircle",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    status: {
      type: String,
      required: !0
    },
    strokeWidth: {
      type: Number,
      required: !0
    },
    fillColor: String,
    railColor: String,
    railStyle: [String, Object],
    percentage: {
      type: Number,
      default: 0
    },
    offsetDegree: {
      type: Number,
      default: 0
    },
    showIndicator: {
      type: Boolean,
      required: !0
    },
    indicatorTextColor: String,
    unit: String,
    viewBoxWidth: {
      type: Number,
      required: !0
    },
    gapDegree: {
      type: Number,
      required: !0
    },
    gapOffsetDegree: {
      type: Number,
      default: 0
    }
  },
  setup($, {
    slots: m
  }) {
    function y(p, o, n) {
      const {
        gapDegree: l,
        viewBoxWidth: a,
        strokeWidth: s
      } = $, t = 50, u = 0, d = t, i = 0, r = 2 * t, c = 50 + s / 2, g = `M ${c},${c} m ${u},${d}
      a ${t},${t} 0 1 1 ${i},${-r}
      a ${t},${t} 0 1 1 ${-i},${r}`, f = Math.PI * 2 * t, h = {
        stroke: n,
        strokeDasharray: `${p / 100 * (f - l)}px ${a * 8}px`,
        strokeDashoffset: `-${l / 2}px`,
        transformOrigin: o ? "center" : void 0,
        transform: o ? `rotate(${o}deg)` : void 0
      };
      return {
        pathString: g,
        pathStyle: h
      };
    }
    return () => {
      const {
        fillColor: p,
        railColor: o,
        strokeWidth: n,
        offsetDegree: l,
        status: a,
        percentage: s,
        showIndicator: t,
        indicatorTextColor: u,
        unit: d,
        gapOffsetDegree: i,
        clsPrefix: r
      } = $, {
        pathString: c,
        pathStyle: g
      } = y(100, 0, o), {
        pathString: f,
        pathStyle: h
      } = y(s, l, p), S = 100 + n;
      return e("div", {
        class: `${r}-progress-content`,
        role: "none"
      }, e("div", {
        class: `${r}-progress-graph`,
        "aria-hidden": !0
      }, e("div", {
        class: `${r}-progress-graph-circle`,
        style: {
          transform: i ? `rotate(${i}deg)` : void 0
        }
      }, e("svg", {
        viewBox: `0 0 ${S} ${S}`
      }, e("g", null, e("path", {
        class: `${r}-progress-graph-circle-rail`,
        d: c,
        "stroke-width": n,
        "stroke-linecap": "round",
        fill: "none",
        style: g
      })), e("g", null, e("path", {
        class: [`${r}-progress-graph-circle-fill`, s === 0 && `${r}-progress-graph-circle-fill--empty`],
        d: f,
        "stroke-width": n,
        "stroke-linecap": "round",
        fill: "none",
        style: h
      }))))), t ? e("div", null, m.default ? e("div", {
        class: `${r}-progress-custom-content`,
        role: "none"
      }, m.default()) : a !== "default" ? e("div", {
        class: `${r}-progress-icon`,
        "aria-hidden": !0
      }, e(P, {
        clsPrefix: r
      }, {
        default: () => C[a]
      })) : e("div", {
        class: `${r}-progress-text`,
        style: {
          color: u
        },
        role: "none"
      }, e("span", {
        class: `${r}-progress-text__percentage`
      }, s), e("span", {
        class: `${r}-progress-text__unit`
      }, d))) : null);
    };
  }
});
export {
  O as default
};
